// Dependency
import React from "react";
import { Helmet } from "react-helmet";

// Template
const Head = ({ data, country, location }) => {
    const SEOdata = data && data.tags ? data.tags : null;

    const mapSEOField = (seoArray, fieldName) => {
        // If SEO fields are missing, exit
        if (!seoArray) { return; }
        // Else find specific array item
        const field = seoArray.find((element) => {
            // Check if it tagName does equal to the field
            // we are looking for
            if (element.tagName === fieldName) {
                // and return the element
                return element;
            }
            // If not, check if element has a attributes field
            if (element.attributes) {
                // and check if the name matches
                if (element.attributes.name === fieldName) {
                    // return the element
                    return element;
                }
                // or if property matches
                if (element.attributes.property === fieldName) {
                    // return the element
                    return element;
                }
            }
        });
        // If field exists
        if (field) {
            // Return it's content or attribute content
            return field.content ? field.content : field.attributes.content
        }
    }

    const mappedFields = (seoArray) => {
        // If SEO fields are missing, exit
        if (!seoArray) { return; }
        // Remove first field ( it is the title, we need only meta )
        const fieldsArray = seoArray.slice(1);
        // Map over fields
        const f = fieldsArray.map((element) => {
            // Check if they are all meta
            if (element.tagName === 'meta') {
                // and return mapped fields in the new format
                // ( required by React Helmet )
                return {
                    ...(element.attributes.name && { 'name': element.attributes.name }),
                    ...(element.attributes.property && { 'property': element.attributes.property }),
                    ...(element.attributes.content && { 'content': element.attributes.content })
                }
            }
        });
        // Return new array with mapped fields
        return f;
    }
    // Get mapped SEO data
    let mappedMeta = mappedFields(SEOdata || []);
    //mappedMeta.push({name:'robots', content: 'noindex'})

    // const hrefLang = {
    //     se: "sv",
    //     dk: "da",
    //     eu: "en"
    // }

    // const countries = ['se', 'dk','eu'];,

    const helloretailWebsiteUuids = {
        se: '35b74b6a-3f28-4db0-aeeb-2c57c56f5060',
        dk: 'eb9ca21d-cd57-48d5-a3b9-82564858f248',
        eu: 'd4c5d97e-1542-4a1f-ab79-4cb0dc568c1e',
        nl: 'a843c984-c143-4551-9e95-6435d4bd1ab0',
        fr: 'f931a363-bc06-4017-bdba-494eadfbe77a',
        no: 'e90e8153-ffc3-4148-9713-ca1baae69f55',
        uk: '6943da4c-0710-4faf-bc43-7e804d88f032',

    }

    return (
        <Helmet
            title={mapSEOField(SEOdata, 'title') ? mapSEOField(SEOdata, 'title') : ' '}
            defer={false}
            meta={mappedMeta}
        >
            {/* {location && countries.map((c, key) => {
                if ( c !== country ) return <link rel="alternate" href={`${location.origin}/${c}/${location.pathname.substring(4)}`} hrefLang={hrefLang[c]} key={key}/>
            })} */}

            <script type="text/javascript" src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js" async></script>
            <script key="ingrid-tracking" src="https://cdn.ingrid.com/delivery-tracking/bootstrap.js" defer />
          
            <script async src="https://helloretailcdn.com/helloretail.js"></script>
            <script>
                {`window.hrq = window.hrq || [];
                hrq.push(['init',
                    {
                        websiteUuid: "${helloretailWebsiteUuids[country]}",
                    }
                ]);`}
            </script>
            <link rel="preconnect" href="https://dev.visualwebsiteoptimizer.com" />
            <script id='vwoCode' type="text/javascript">
                {`window._vwo_code || (function() {
var account_id=792127,
version=2.0,
settings_tolerance=2000,
hide_element='body',
hide_element_style = 'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important',
/* DO NOT EDIT BELOW THIS LINE */
f=false,w=window,d=document,v=d.querySelector('#vwoCode'),cK='_vwo_'+account_id+'_settings',cc={};try{var c=JSON.parse(localStorage.getItem('_vwo_'+account_id+'_config'));cc=c&&typeof c==='object'?c:{}}catch(e){}var stT=cc.stT==='session'?w.sessionStorage:w.localStorage;code={use_existing_jquery:function(){return typeof use_existing_jquery!=='undefined'?use_existing_jquery:undefined},library_tolerance:function(){return typeof library_tolerance!=='undefined'?library_tolerance:undefined},settings_tolerance:function(){return cc.sT||settings_tolerance},hide_element_style:function(){return'{'+(cc.hES||hide_element_style)+'}'},hide_element:function(){return typeof cc.hE==='string'?cc.hE:hide_element},getVersion:function(){return version},finish:function(){if(!f){f=true;var e=d.getElementById('_vis_opt_path_hides');if(e)e.parentNode.removeChild(e)}},finished:function(){return f},load:function(e){var t=this.getSettings(),n=d.createElement('script'),i=this;if(t){n.textContent=t;d.getElementsByTagName('head')[0].appendChild(n);if(!w.VWO||VWO.caE){stT.removeItem(cK);i.load(e)}}else{n.fetchPriority='high';n.src=e;n.type='text/javascript';n.onerror=function(){_vwo_code.finish()};d.getElementsByTagName('head')[0].appendChild(n)}},getSettings:function(){try{var e=stT.getItem(cK);if(!e){return}e=JSON.parse(e);if(Date.now()>e.e){stT.removeItem(cK);return}return e.s}catch(e){return}},init:function(){if(d.URL.indexOf('__vwo_disable__')>-1)return;var e=this.settings_tolerance();w._vwo_settings_timer=setTimeout(function(){_vwo_code.finish();stT.removeItem(cK)},e);var t=d.currentScript,n=d.createElement('style'),i=this.hide_element(),r=t&&!t.async&&i?i+this.hide_element_style():'',c=d.getElementsByTagName('head')[0];n.setAttribute('id','_vis_opt_path_hides');v&&n.setAttribute('nonce',v.nonce);n.setAttribute('type','text/css');if(n.styleSheet)n.styleSheet.cssText=r;else n.appendChild(d.createTextNode(r));c.appendChild(n);this.load('https://dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(d.URL)+'&vn='+version)}};w._vwo_code=code;code.init();})();`}
            </script>
        </Helmet>
    )
}

export default Head;